import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { utils } from "@alife/cone-arms-core";
import { observeEventDelay } from "./observe-event-delay";
import { init as initObservePageScroll, getScrollPageTimes, reset as resetScrollPageTimes } from "./observe-page-scroll";
import { init as initDomTreeObserver } from "./observe-domtree-change";
import { initLongTaskObserver } from "./observe-long-task";
import { initResourceObserver } from "./observe-resource-load";
var checkWin = utils.checkWin, getCommonInfo = utils.getCommonInfo, hookHashChange = utils.hookHashChange, hookHistory = utils.hookHistory, bindEvent = utils.bindEvent;
var TraceWebRuntimePlugin = function(core) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!(core && checkWin())) return;
    var startTime = new Date();
    var clickTimes = 0;
    var commonInfo = {};
    var timerId;
    var domTreeObserver = initDomTreeObserver();
    var eventDelayObserver = observeEventDelay();
    var longTaskObserver = initLongTaskObserver();
    var resourceObserver = initResourceObserver();
    var init = function() {
        startTime = new Date();
        clickTimes = 0;
        commonInfo = getCommonInfo(core.config.ignoredQueries || [], core.config);
        eventDelayObserver === null || eventDelayObserver === void 0 ? void 0 : eventDelayObserver.reset();
        resetScrollPageTimes();
        domTreeObserver.reset();
        longTaskObserver === null || longTaskObserver === void 0 ? void 0 : longTaskObserver.reset();
        resourceObserver === null || resourceObserver === void 0 ? void 0 : resourceObserver.reset();
    };
    var log = function() {
        var eventResponseDelayList = (eventDelayObserver === null || eventDelayObserver === void 0 ? void 0 : eventDelayObserver.getLongEventList()) || [];
        var longTaskList = (longTaskObserver === null || longTaskObserver === void 0 ? void 0 : longTaskObserver.getData()) || [];
        core.logRunTime(_object_spread(_object_spread_props(_object_spread({}, commonInfo), {
            stayTime: Math.ceil((new Date().getTime() - startTime.getTime()) / 1000),
            clickTimes: clickTimes,
            scrollPageTimes: getScrollPageTimes(),
            eventResponseDelayList: eventResponseDelayList,
            eventResponseDelayTimes: eventResponseDelayList.length,
            longTaskList: longTaskList,
            longTaskTimes: longTaskList.length
        }), domTreeObserver.getData(), (resourceObserver === null || resourceObserver === void 0 ? void 0 : resourceObserver.getData()) || {}));
    };
    init();
    var handleBeforeunload = function() {
        log();
    };
    var handleSpaPageChange = function() {
        clearTimeout(timerId);
        timerId = setTimeout(function() {
            var _getCommonInfo;
            var url = (_getCommonInfo = getCommonInfo(core.config.ignoredQueries || [], core.config)) === null || _getCommonInfo === void 0 ? void 0 : _getCommonInfo.url;
            if (url !== (commonInfo === null || commonInfo === void 0 ? void 0 : commonInfo.url)) {
                log();
                init();
            }
        }, 50);
    };
    var unbindBeforeunload = bindEvent(window, "beforeunload", handleBeforeunload);
    var routeType = config.routeType || core.config.spaRouteType;
    var unbindHashChange = routeType !== "history" ? hookHashChange(handleSpaPageChange) : function() {};
    var unbindHistoryChange = routeType !== "hash" ? hookHistory(handleSpaPageChange) : function() {};
    var unbindPageScrollEvent = initObservePageScroll();
    var unbindClickEvent = bindEvent(window, "mousedown", function() {
        clickTimes += 1;
    });
    return function() {
        unbindHashChange();
        unbindHistoryChange();
        unbindBeforeunload();
        unbindPageScrollEvent();
        unbindClickEvent();
        domTreeObserver.unbind();
        eventDelayObserver === null || eventDelayObserver === void 0 ? void 0 : eventDelayObserver.unbind();
        longTaskObserver === null || longTaskObserver === void 0 ? void 0 : longTaskObserver.unbind();
        resourceObserver === null || resourceObserver === void 0 ? void 0 : resourceObserver.unbind();
    };
};
export default TraceWebRuntimePlugin;
